import blackjackPreview from "./blackjack/blackjack-preview.svg";
import bankPreview from "./fortune-bank-preview.svg";
import slotsPreview from "./cyber-slots-preview.jpg";
import { lazy, type ComponentType, type LazyExoticComponent } from "react";

export interface FortuneDefinition {
  name: string;
  title: string;
  createdAt: string;
  description: string;
  image: string;
  tags: string[];
  component: LazyExoticComponent<ComponentType>;
}

export const fortuneDefinitions: FortuneDefinition[] = [
  {
    name: "blackjack",
    title: "Blackjack",
    createdAt: "2026-11-03",
    description:
      "Take a seat, play your hand, and challenge the dealer with Fortune Dollars.",
    image: blackjackPreview,
    tags: ["Cards", "Fortune Dollars"],
    component: lazy(() => import("./blackjack/Blackjack"))
  },
  {
    name: "fortune-bank",
    title: "Fortune Bank",
    createdAt: "2026-11-01",
    description:
      "Your Fortune Dollars account. See your balance and a statement of every bet and win.",
    image: bankPreview,
    tags: ["Virtual currency", "Account statement"],
    component: lazy(() => import("./FortuneBank"))
  },
  {
    name: "cyber-slots",
    title: "Cyber Slots",
    createdAt: "2026-11-01",
    description:
      "Play twenty paylines across five neon reels, with wilds and Overclock free spins.",
    image: slotsPreview,
    tags: ["Slots", "Fortune Dollars"],
    component: lazy(() => import("./CyberSlots"))
  }
];
